var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading && !_vm.hasError)?_c('div',{staticClass:"spinner text-center"},[_c('i',{staticClass:"fas fa-spinner"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }